import { Controller } from "@hotwired/stimulus"
import { get } from "@lib/requests"

export default class extends Controller {
  
  static targets = ["clinic", "vet"]

  static values = { filter: { type: Boolean, default: true }, vetId: { type: Number, default: null } }
  
  async change() {
    await get(`/vets?clinic_id=${this.clinicTarget.value}&vet_id=${this.vetIdValue}`, { responseKind: "turbo-stream" })
  }

  onClinicChange(e) {
    const clinicId = e.target.value
    
    // Emit a custom event to notify other controllers that the vet select has been updated
    this.clinicTarget.dispatchEvent(new CustomEvent("clinic-change", { detail: clinicId, bubbles: true }))
    
    // If we don't want to filter the vets, we can stop here
    if (!this.filterValue) return
    
    if (!clinicId) return this.vetTarget.innerHTML = ""
    
    const option = e.target.querySelector(`option[value="${clinicId}"]`)
    const vets = JSON.parse(option.dataset.vets)

    let optionsHTML = `<option value=""></option>`
    
    if (vets.length === 1) {
      optionsHTML += `<option value="${vets[0].id}" selected>${vets[0].name}</option>`
    } else {
      optionsHTML += vets.map(vet => `<option value="${vet.id}">${vet.name}</option>`).join("")
    }
    
    this.vetTarget.innerHTML = optionsHTML
    this.vetTarget.focus()
  }
  
}
